const deviceSticksTypes = {
    TEREA: 'TEREA',
    LEVIA: 'LEVIA',
    DELIA: 'DELIA',
};

export default deviceSticksTypes;
